// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var DemoSourceType;
(function (DemoSourceType) {
    DemoSourceType["OTHERPMS"] = "OTHERPMS";
    DemoSourceType["CSV"] = "CSV";
    DemoSourceType["CUSTOM_CONTACT"] = "CUSTOM_CONTACT";
    DemoSourceType["WEAVE_PMS_NON_VET"] = "WEAVE_PMS_NON_VET";
    DemoSourceType["WEAVE_PMS_VET"] = "WEAVE_PMS_VET";
})(DemoSourceType || (DemoSourceType = {}));
export var DemoSourceType_index;
(function (DemoSourceType_index) {
    DemoSourceType_index[DemoSourceType_index["OTHERPMS"] = 0] = "OTHERPMS";
    DemoSourceType_index[DemoSourceType_index["CSV"] = 1] = "CSV";
    DemoSourceType_index[DemoSourceType_index["CUSTOM_CONTACT"] = 2] = "CUSTOM_CONTACT";
    DemoSourceType_index[DemoSourceType_index["WEAVE_PMS_NON_VET"] = 3] = "WEAVE_PMS_NON_VET";
    DemoSourceType_index[DemoSourceType_index["WEAVE_PMS_VET"] = 4] = "WEAVE_PMS_VET";
})(DemoSourceType_index || (DemoSourceType_index = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["ACTIVE"] = "ACTIVE";
    Status["INACTIVE"] = "INACTIVE";
})(Status || (Status = {}));
export var Status_index;
(function (Status_index) {
    Status_index[Status_index["UNKNOWN"] = 0] = "UNKNOWN";
    Status_index[Status_index["ACTIVE"] = 1] = "ACTIVE";
    Status_index[Status_index["INACTIVE"] = 2] = "INACTIVE";
})(Status_index || (Status_index = {}));
